<template>
  <div>
    <v-card flat>
      <v-card-title>
        <h6 class="mb-0">Liste des Campagnes de {{ animateur.displayName }}</h6>
      </v-card-title>
      <v-card-text>
        <v-data-table
          dense
          :headers="headers"
          :items="parcours_effectifs"
          :search="search"
          item-key="id"
          locale="fr"
        >
          <template v-slot:item.actions="{ item }">
            <div class="row">
              <div v-if="item.verified"></div>
              <buttonCheckCampagnes
                v-else
                :key="$uuid.v4()"
                :id_groupe="item.groupes_id_groupe"
                :parcours_effectif="item"
                :animateur="animateur"
                :user="user"
                @recharger="GetCampagnesDeAnimateur()"
              />
            </div>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  components: {
    buttonCheckCampagnes: require("@/components/groupes/buttonCheckCampagnes.vue")
      .default,
  },
  created() {
    this.GetCampagnesDeAnimateur();
  },
  data() {
    return {
      cle: this.$uuid.v4(),
      search: "",
      parcours_effectifs: [],
      headers: [
        {
          text: "Groupe",
          label: "Groupe",
          value: "nom_groupe",
          field: "nom_groupe",
        },

        {
          text: "Campagne",
          value: "ll_parcours_effectif",
          label: "Campagne",
          field: "ll_parcours_effectif",
        },
        {
          text: "Projet",
          value: "ll_programme",
          label: "Projet",
          field: "ll_programme",
        },
        {
          text: "Date",
          value: "date_debut",
          label: "Date",
          field: "date_debut",
        },

        {
          text: "Animateur",
          value: "nom_responsable",
          label: "Animateur",
          field: "nom_responsable",
        },
        {
          text: "Région",
          value: "ll_region",
          label: "Région",
          field: "ll_region",
        },
        {
          text: "District",
          value: "ll_district",
          label: "District",
          field: "ll_district",
        },
        {
          text: "Commune",
          value: "ll_commune",
          label: "Commune",
          field: "ll_commune",
        },
        {
          text: "Fokontany",
          value: "ll_fokontany",
          label: "Fokontany",
          field: "ll_fokontany",
        },
        {
          text: "Vérifié par",
          value: "verifiedBy",
          label: "Vérifié par",
          field: "verifiedBy",
        },

        { text: "", value: "actions" },
      ],
    };
  },
  props: {
    animateur: {
      required: true,
    },
    user: {
      required: true,
    },
  },
  methods: {
    GetCampagnesDeAnimateur() {
      let self = this;
      this.loading = true;

      self.parcours_effectifs = [];
      this.$firebase
        .firestore()
        .collection("parcours_effectif")
        .where("id_responsable", "==", self.animateur.id)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            self.parcours_effectifs.push({
              ...doc.data(),
              id: doc.id,
            });
          });

          self.loading = false;
        })
        .catch((error) => {
          console.log("Error getting documents: ", error);
        });
    },
  },
};
</script>

<style scoped></style>
